import { render, staticRenderFns } from "./NewEditPeiPage.vue?vue&type=template&id=17f1ebad&scoped=true"
import script from "./NewEditPeiPage.vue?vue&type=script&lang=js"
export * from "./NewEditPeiPage.vue?vue&type=script&lang=js"
import style0 from "./NewEditPeiPage.vue?vue&type=style&index=0&id=17f1ebad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f1ebad",
  null
  
)

export default component.exports